"use strict";
/* This is a generated file, do not edit */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelTask_Response = void 0;
var CancelTask_Response = /** @class */ (function () {
    function CancelTask_Response(fields) {
        if (fields === void 0) { fields = {}; }
        this.success = fields.success || false;
        this.message = fields.message || '';
    }
    CancelTask_Response.validate = function (obj) {
        if (typeof obj['success'] !== 'boolean') {
            throw new Error('expected "success" to be "boolean"');
        }
        if (typeof obj['message'] !== 'string') {
            throw new Error('expected "message" to be "string"');
        }
    };
    CancelTask_Response.FullTypeName = 'rmf_task_msgs/srv/CancelTask_Response';
    return CancelTask_Response;
}());
exports.CancelTask_Response = CancelTask_Response;
/*


# Confirmation that this service call is processed
bool success

# This will provide a verbose message regarding task cancellation
string message


*/
